<br><br>

<div class="container div-border">
  <div class="row">
    <div class="col-3 heading">{{'Name'|translate}}</div>
    <div class="col-3 heading">{{'Description'|translate}}</div>
    <div class="col-6 heading"></div>
  </div>
  <div class="row change-font">
    <div class="col-3">{{'Error Report'|translate}} </div>
    <div class="col-3">{{'Report on Technical Problem'|translate}}</div>
    <div class="col-6"><input type="button" (click)="navigateToReportErrors()"
                              value="{{'Select'|translate}}"></div>
  </div>
  <div class="row row1">
    <div class="col-3">{{'VIN Report'|translate}} </div>
    <div class="col-3">{{'Report on VIN Issue'|translate}}</div>
    <div class="col-6"><input type="button" (click)="navigateToReportVINIssue() "
                              value="{{'Select'|translate}}"></div>
  </div>
  <div class="row change-font">
    <div class="col-3">{{'VIN not Readable Report'|translate}} </div>
    <div class="col-3">{{'Report on VIN not readable'|translate}}</div>
    <div class="col-6"><input type="button" (click)="navigateToReportReadVin()"
                              value="{{'Select'|translate}}"></div>
  </div>
  <div class="row row1">
    <div class="col-3">{{'VCI Issue Report'|translate}} </div>
    <div class="col-3">{{'Report on Issue with VCI'|translate}}</div>
    <div class="col-6"><input type="button" (click)="navigateToReportVci()"
                              value="{{'Select'|translate}}"></div>
  </div>
  <div class="row change-font">
    <div class="col-3">{{'Lost Communication Report'|translate}} </div>
    <div class="col-3">{{'Report on Lost Communication'|translate}}</div>
    <div class="col-6"><input type="button" (click)="navigateToReportLostCommunication()"
                              value="{{'Select'|translate}}"></div>
  </div>
  <div class="row row1">
    <div class="col-3">{{'VIN Mismatch Report'|translate}} </div>
    <div class="col-3">{{'Report on VIN Mismatch'|translate}}</div>
    <div class="col-6"><input type="button" (click)="navigateToVinMismatchErrors()"
                              value="{{'Select'|translate}}"></div>
  </div>

  <div class="row change-font">
    <div class="col-3">{{'Unsupported Browser Report'|translate}} </div>
    <div class="col-3">{{'Report on Unsupported Browser'|translate}}</div>
    <div class="col-6"><input type="button" (click)="navigateToUnsupportedBrowser()"
                              value="{{'Select'|translate}}"></div>
  </div>

<br>
<div class="row change-font">
  <div class="col-6">{{'Document explaining method to replicate each pop up error message'|translate}} </div>
  <div class="col-6">
    <input type="button" (click)="openPdfDocument()" value="{{'PDF'|translate}}"  style="width: 55px;">
  </div>
</div>
</div>
